// import { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
// import { Auth } from "aws-amplify";
import { isAuth } from "../apollo/cache";
import { RenderWhatIsNewByFeature } from "WhatIsNew";


const PublicRoute = ({ component: Component, restricted, provider: Provider, flagWhatNew, ...rest }) => {
  // const [loading, setLoading] = useState(true);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const isAuth = await isAuthenticated();
  //     setIsLoggedIn(isAuth);
  //     setLoading(false);
  //   };
  //   fetchData();
  //   return function cleanup() {}
  // }, []);

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={(props) =>
        isAuth() && restricted ? (
          <Redirect to="/mainmenu" />
        ) : Provider ? (
          <Provider>
            {flagWhatNew && <RenderWhatIsNewByFeature flagWhatNew={flagWhatNew} />}
            <Component {...props} />
          </Provider>
        ) : (
          <>
            {flagWhatNew && <RenderWhatIsNewByFeature flagWhatNew={flagWhatNew} />}
            <Component {...props} />
          </>
        )
      }
    />
  );
};

export default PublicRoute;
